import { useState, useEffect } from 'react';
import Layout from "../Layout";
import { Link, useLocation } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

const data = {
        page1: 'APPLIED ARTS AND SCIENCE DIVISION',
        departments1: [
            { 
                name: "Applied Art",
                imgLink: '/img/subject/applied-art.jpg',
                linkTo: "/departments/applied-arts"
            }, 
            { 
                name: "Applied Science",
                imgLink: '/img/subject/applied-science.jpg',
                linkTo: "/departments/aplied-science"
            }, 
            { 
                name: "Hospitality",
                imgLink: '/img/subject/hospitality.jpg',
                linkTo: "/departments/hospitality"
            }
        ],
        page2: 'CIVIL AND CONSTRUCTION DIVISION',
        departments2: [
            { 
                name: "Construction",
                imgLink: '/img/subject/construction.jpg',
                linkTo: "/departments/construction"
            }, 
            { 
                name: "Wood Technology",
                imgLink: '/img/subject/wood.jpg',
                linkTo: "/departments/wood-technology"
            }, 
            { 
                name: "Civil Engineering",
                imgLink: '/img/subject/civil-eng.jpg',
                linkTo: "/departments/ced"
            }
        ],
        page3: 'ENGINEERING DIVISION',
        departments3: [
            { 
                name: "Automotive",
                imgLink: '/img/subject/automative.jpg',
                linkTo: "/departments/automotive"
            }, 
            { 
                name: "Electrical",
                imgLink: '/img/subject/electrical-eng.jpg',
                linkTo: "/departments/electrical"
            }, 
            { 
                name: "Mechanical",
                imgLink: '/img/subject/mech-eng.jpg',
                linkTo: "/departments/mechanical"
            },
            { 
                name: "Mining",
                imgLink: '/img/subject/mining.jpg',
                linkTo: "/departments/mining"
            }
        ],
        page4: 'COMMERCE DIVISION',
        departments4: [
            { 
                name: "Business Studies",
                imgLink: '/img/subject/business-studies.jpg',
                linkTo: "/departments/business-studies"
            }, 
            { 
                name: "Management Studies",
                imgLink: '/img/subject/management-studies.jpg',
                linkTo: "/departments/management-studies"
            }, 
            { 
                name:"Office Management",
                imgLink: '/img/subject/management-studies.jpg',
                linkTo: "/departments/office-management"
            },
            { 
                name:"IM Systems",
                imgLink: '/img/subject/im-systems.jpg',
                linkTo: "/departments/im-systems"
            }
        ],
        page5: 'RESEARCH EDUCATION AND ENTERPRISE DEVELOPMENT DIVISION',
        departments5: [
            { 
                name:"Education",
                imgLink: '/img/subject/teach.jpg',
                linkTo: "/departments/education"
            }
            
        ]
        
    }

const Departments = () => {
    const [heading, setHeading] = useState('');
    const [departments, setDepartments] = useState([]);

    const location = useLocation();

    useEffect(() => {
        if(location.pathname === '/division/artsAndScience') {
            setHeading(data.page1);
            setDepartments(data.departments1)
        } else if(location.pathname === '/division/ccd') {
            setHeading(data.page2);
            setDepartments(data.departments2)
        } else if(location.pathname === '/division/engineering') {
            setHeading(data.page3);
            setDepartments(data.departments3)
        } else if(location.pathname === '/division/commerce') {
            setHeading(data.page4);
            setDepartments(data.departments4)
        } else if (location.pathname === '/division/reed') {
            setHeading(data.page5);
            setDepartments(data.departments5)
        } else {
            setHeading(data.page1);
            setDepartments(data.departments1)
        }
    }, [departments,location]);
  
    return ( 
        <Layout>
            <Helmet> 
                <meta
                    name="description"
                    content="Life Long Polytechnic has a wide variety of academic divisions."
                />
                <title>{heading.toLowerCase()}</title>
            </Helmet>
            <div className="light-bg">
                <div className="container">
                    <h6 className="has-text-weight-semibold pt-6 pb-2 is-size-4">{heading}</h6>
                    <div className="divider"></div>

                    
                    <div className="row mt-5">
                        {
                            departments && departments.map(department => (
                                <div className="col s12 m6 l4" key={department.linkTo}>
                                    <div className="card mb-5">
                                        <div className="card-image">
                                            <img src={department.imgLink} alt={department.name} />
                                        </div>
                                        <div className="card-content center">
                                            <Link to={department.linkTo} className="is-size-6 main-color-text has-text-weight-semibold">{ department.name }</Link>
                                            <FaArrowRight className="main-color-text ml-2 pt-1" />
                                        </div>
                                    </div>
                                </div>
                            ))
                        }                  
                    </div>               
                </div>
                <div className="container center">
                    <div className="control mb-4">
                        <Link to="/" className="button is-rounded main-color mt-3 mb-4">
                            <span className="icon">
                                <FaArrowLeft color="white"/>
                            </span>
                            <span className="white-text">Back Home</span>
                        </Link>
                    </div>
                </div>   
            </div>
        </Layout>
     );
}
 
export default Departments;